/* eslint-disable no-unused-vars */
export enum ButtonTags {
  BUTTON = 'button',
  A = 'a',
  SPAN = 'span',
}
